export const BULK_UPLOAD_START = 'BULK_UPLOAD_START';
export const BULK_UPLOAD_END = 'BULK_UPLOAD_END';
export const BULK_UPLOAD_UPDATE = 'BULK_UPLOAD_UPDATE';
export const REMOVE_UPLOADED_ITEM_FROM_STATE = 'REMOVE_UPLOADED_ITEM_FROM_STATE';
export const FLUSH_UPLOADED_ITEMS_STATE = 'FLUSH_UPLOADED_ITEMS_STATE';

